import React from "react";

import {
  BellRinging,
  ChartLine,
  Folder,
  Money,
  UsersFour,
  Warning,
} from "phosphor-react";
import { Navigate } from "react-router-dom";

import ApiClient from "~/admin/services/ApiClient";
import Authentication from "~/admin/services/Authentication";
import AdminPrivateLayout from "~/admin/layouts/privateLayout/AdminPrivateLayout";

export default function AdminLayout(props) {
  const sideMenuItems = [
    {
      menuKey: "stats",
      label: "Statistiques",
      icon: <ChartLine />,
      path: "",
      loadNotifs: false,
    },
    {
      menuKey: "users",
      label: "Utilisateurs",
      icon: <UsersFour />,
      path: "users",
      loadNotifs: false,
    },
    {
      menuKey: "demands",
      label: "Demandes",
      icon: <BellRinging />,
      path: "demands",
      loadNotifs: true,
    },
    {
      menuKey: "contents",
      label: "Contenus",
      icon: <Folder />,
      path: "contents",
      loadNotifs: false,
    },
    {
      menuKey: "reports",
      label: "Signalements",
      icon: <Warning />,
      path: "reports",
      loadNotifs: false,
    },
    {
      menuKey: "bills",
      label: "Factures",
      icon: <Money />,
      path: "bills",
      loadNotifs: false,
    },
  ];

  return Authentication.isLogged() ? (
    <AdminPrivateLayout
      {...props}
      unauthorizedRoutePath="login"
      authentication={Authentication}
      apiClient={ApiClient}
      sideMenuItems={sideMenuItems}
      routesPrefix="admin"
      titleBarButtons={<>Accueil</>}
    />
  ) : (
    <Navigate to="/admin/login" replace />
  );
}
